import {
  FormattedOwnerData,
  OwnerData,
  OwnerDataCups,
} from "../../core/models/ownerData/ownerData.model";

const formatOwnerData = (ownerData: OwnerData): FormattedOwnerData => {
  const {
    IsAdministrador: isAdministrator,
    DatosPersonales: personalData,
    DatosAdministrador: administratorData,
    NumeroSuministros,
    CUPS,
    flags,
  } = ownerData;

  return {
    isAdministrator,
    firstClientSurname: personalData?.Apellido1Cliente || "",
    secondClientSurname: personalData?.Apellido2Cliente || "",
    clientName: personalData?.NombreCliente || "",
    clientIdentification: personalData?.IdentificadorClienteDNI || "",
    socialReason: personalData?.RazonSocialCliente || "",
    idClient: personalData?.IdCliente.toString() || "",
    administratorName: administratorData?.NombreAdministrador || "",
    idAdministrator: administratorData?.IdAdministrador || "",
    entitiesNumber: administratorData?.NumeroEntidades || "",
    supplyNumber: NumeroSuministros || "",
    cups: CUPS?.length
      ? CUPS.map(
          ({
            CodigoCups,
            IdCups,
            IdContrato,
            IdentidadTitular,
            Entorno,
            Calle,
            Numero,
            Tarifa,
            Ciudad,
            CodigoContrato,
            RazonSocial,
            IdContratoSituacion,
            FechaAlta,
          }) => ({
            codeCups: CodigoCups,
            idCups: IdCups,
            idContract: IdContrato,
            cif: IdentidadTitular,
            envirorment: Entorno,
            fee: Tarifa,
            address: `${Calle}${Numero ? ", " + Numero : ""}`,
            town: Ciudad,
            contractCode: CodigoContrato,
            socialReason: RazonSocial,
            situation: IdContratoSituacion === 1 ? "Contrato" : "",
            date: FechaAlta,
          })
        )
      : [],
    isAgent: flags.EsAgente || false,
  };
};

const initialOwnerDataCup: OwnerDataCups = {
  idCups: "",
  idContract: "",
  codeCups: "",
  address: "",
  cif: "",
  fee: "",
  envirorment: "",
  town: "",
  contractCode: "",
  socialReason: "",
  date: "",
  situation: "",
};

export { formatOwnerData, initialOwnerDataCup };
